import throttle from "lodash/throttle";
import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color";
import { BsFillFileMinusFill, BsFillPlusSquareFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { setCanvasProperty } from "../action";
import { FIGURE_BOX } from "../constants";

export function FigureBox() {
    const figure = useSelector(state => state['features/base/canvas'].figure);
    const dispatch = useDispatch();

    const onClick = (value) => {
        dispatch(setCanvasProperty({ figure: value, showOption: false }));
    }

    return (
        <>
            <div className="figure">
                <ul>
                    { FIGURE_BOX.map((value, i) => {
                        const isValue = value === figure ? true :  false;
                        const isFillValue = `fill_${value}` === figure ? true : false;

                        return (
                            <React.Fragment key={`${i}_${value}`} >
                                <li className={`boardImg ${value} ${value}_${isValue}`} onClick={() => onClick(value)}></li>
                                <li className={`boardImg fill_${value} fill_${value}_${isFillValue}`} onClick={() => onClick(`fill_${value}`)}></li>
                            </React.Fragment>
                        )
                    })}
                </ul>                
            </div>
        </>
    )
}

const eraserType = [true, false];
export function OpacityBox() {
    const dispatch = useDispatch();
    const opacity = useSelector(state => state["features/base/canvas"].opacity);
    
    const onChange = e => {
        dispatch(setCanvasProperty({ opacity: e.target.value }));
    }

    return (
        <>           
            <div className="zoom_box field">
                <div className="value">1</div>
                <input 
                    type="range" name="range"
                    min="0.1" max="1"
                    step="0.1"
                    value={opacity} 
                    onChange={onChange} />
                <label htmlFor="range"> {opacity*10} </label>
                <div className="value nonSelect">10</div>
            </div>
        </>
    )
}

export function ColorBox() {
    const dispatch = useDispatch();
    const currentColor = useSelector(state => state["features/base/canvas"].color);

    const onChange = e => {
        dispatch(setCanvasProperty({ color: e.hex }));
    }

    return (
        <>
            <SketchPicker className="color_box"
                color={currentColor}
                onChange={onChange}
            />
        </>
    )
}

export function EraserBox() {
    const dispatch = useDispatch();
    const isPartEraser = useSelector(state => state["features/base/canvas"].isPartEraser);

    const onClick = isPartEraser => {
        dispatch(setCanvasProperty({ isPartEraser }));
    };

    return (
        <>
            { eraserType.map((name, index) => {                
                const type = name ? "part" : "object";
                return ( 
                    <span key={index}
                        className={`boardImg eraser_${type} eraser_${type}_${name === isPartEraser}`}
                        onClick={() => onClick(name)}
                    ></span>
                );
            }) }
        </>
    )
}

function SwitchFitCanvas({dispatch, name, type, isFit}) {
    const onClick = () => {
        dispatch(setCanvasProperty({ isWidthFit: type, zoom: 100 }));
    }

    return (
        <span style={{margin: "0 8px"}} className={`boardImg ${name} ${name}_${isFit}`}  onClick={onClick} onTouchEnd={onClick}></span>
    );
}

export function ZoomBox() {
    const dispatch = useDispatch();
    const { isWidthFit, zoom } = useSelector(state => state["features/base/canvas"]);

    const [scale, setScale] = useState(zoom);
    
    const onChange = e => setScale(e.target.value);

    useEffect(() => {
        setScale(zoom);
    }, [zoom]);

    useEffect(() => {
        dispatch(setCanvasProperty({ zoom: scale }));      
    }, [scale]);

    const minusScale = () => {
        if (scale - 10 > 50) setScale(scale - 10);
    }

    const plusScale = () => {
        if (scale + 10 <= 300) setScale(scale + 10);
    }

    return (
        <>
            <div className="zoom_box field option_scale">
                <BsFillFileMinusFill onClick={minusScale} size={18} />
                <span>{scale}</span>
                <BsFillPlusSquareFill  onClick={plusScale} size={18}/>
            </div>

            <div style={{ marginTop: "20px"}}>
                <SwitchFitCanvas dispatch={dispatch} name='fitPage' type={undefined} isFit={isWidthFit === undefined} />
                <SwitchFitCanvas dispatch={dispatch} name='fitWidth' type={true} isFit={isWidthFit === true} />
                <SwitchFitCanvas dispatch={dispatch} name='fitHeight' type={false} isFit={isWidthFit === false}/>
            </div>
        </>
    )
}

export function ThicknessBox () {
    const dispatch = useDispatch();
    const thickness = useSelector(state => state["features/base/canvas"].thickness);
    const [zoom, setZoom] = useState(thickness);

    const onChange = e => setZoom(e.target.value);

    useEffect(() => {
        dispatch(setCanvasProperty({ thickness: zoom }));
    }, [zoom]);

    return (
        <div className="zoom_box field">
            <div className="value">1</div>
            <input 
                type="range" name="range"
                min="1" max="20"
                step="1"
                value={zoom} 
                onChange={onChange} />
            <label htmlFor="range"> {zoom} </label>
            <div className="value nonSelect">20</div>
        </div>
    )
}